var map = {
	"./Bitter.svg": 68760,
	"./Bitter_small.svg": 94049,
	"./ChinChin.svg": 54514,
	"./ChinChin_small.svg": 2043,
	"./Cool.svg": 56126,
	"./Cool_small.svg": 4332,
	"./Elephant.svg": 92698,
	"./Elephant_small.svg": 77590,
	"./G.svg": 92819,
	"./G_small.svg": 34483,
	"./IQPizza.svg": 1166,
	"./IQPizza_small.svg": 94147,
	"./Libkin.svg": 79990,
	"./Libkin_small.svg": 12832,
	"./Merci.svg": 11448,
	"./Merci_small.svg": 76570,
	"./PizzaDAY.svg": 65728,
	"./PizzaDay_small.svg": 13810,
	"./Pomodoro.svg": 64232,
	"./Pomodoro_small.svg": 56978,
	"./VarDelivery.svg": 90185,
	"./VarDelivery_small.svg": 11748
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 67628;